import type { RouteRecordRaw } from 'vue-router'

// Route table. Routes are private by default; mark `meta.public: true` to allow anonymous access
// (the navigation guard enforces this). M1 covers auth, dashboard, leagues, invites, and players.
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/features/dashboard/HomeView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/features/auth/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/features/auth/RegisterView.vue'),
    meta: { public: true },
  },
  {
    path: '/leagues/:leagueId',
    name: 'league-home',
    component: () => import('@/features/leagues/LeagueHomeView.vue'),
  },
  {
    path: '/leagues/:leagueId/draft',
    name: 'draft-room',
    component: () => import('@/features/draft/DraftRoomView.vue'),
  },
  {
    path: '/leagues/:leagueId/team',
    name: 'lineup-editor',
    component: () => import('@/features/scoring/LineupEditorView.vue'),
  },
  {
    path: '/leagues/:leagueId/matchups',
    name: 'scoreboard',
    component: () => import('@/features/scoring/ScoreboardView.vue'),
  },
  {
    path: '/leagues/:leagueId/matchups/:matchupId',
    name: 'matchup-detail',
    component: () => import('@/features/scoring/MatchupDetailView.vue'),
  },
  {
    path: '/leagues/:leagueId/standings',
    name: 'standings',
    component: () => import('@/features/scoring/StandingsView.vue'),
  },
  {
    path: '/leagues/:leagueId/free-agents',
    name: 'free-agents',
    component: () => import('@/features/transactions/FreeAgentsView.vue'),
  },
  {
    path: '/leagues/:leagueId/waivers',
    name: 'waivers',
    component: () => import('@/features/transactions/WaiversView.vue'),
  },
  {
    path: '/leagues/:leagueId/trades',
    name: 'trades',
    component: () => import('@/features/transactions/TradesView.vue'),
  },
  {
    path: '/leagues/:leagueId/transactions',
    name: 'transactions',
    component: () => import('@/features/transactions/TransactionsView.vue'),
  },
  {
    // Commissioner tools. The view itself gates on `isCommissioner` (backend authoritative).
    path: '/leagues/:leagueId/commissioner',
    name: 'commissioner',
    component: () => import('@/features/commissioner/CommissionerView.vue'),
  },
  {
    // Site admin area. `meta.adminOnly` is a UX gate in the guard; the backend enforces SiteAdmin.
    path: '/admin',
    name: 'admin',
    component: () => import('@/features/admin/AdminView.vue'),
    meta: { adminOnly: true },
  },
  {
    // Simulation leagues: create + list (site admin tooling).
    path: '/admin/simulations',
    name: 'simulations',
    component: () => import('@/features/admin/simulations/SimulationListView.vue'),
    meta: { adminOnly: true },
  },
  {
    // One simulation's control panel (virtual clock, mock draft, teardown).
    path: '/admin/simulations/:leagueId',
    name: 'simulation-control',
    component: () => import('@/features/admin/simulations/SimulationControlView.vue'),
    meta: { adminOnly: true },
  },
  {
    // Public so an invitee can land here while signed out; the view prompts for sign-in and the
    // accept call itself requires a cookie session.
    path: '/invite/:token',
    name: 'accept-invite',
    component: () => import('@/features/leagues/AcceptInviteView.vue'),
    meta: { public: true },
  },
  {
    path: '/players',
    name: 'players',
    component: () => import('@/features/players/PlayersView.vue'),
  },
  {
    path: '/players/:playerId',
    name: 'player-detail',
    component: () => import('@/features/players/PlayerDetailView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/features/common/NotFoundView.vue'),
    meta: { public: true },
  },
]
